import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import "firebase/performance";
import "firebase/firestore";

// Initialize Firebase
var config =  {
  apiKey: "AIzaSyCNhDa6Unj5HQC6Wo59IudCISCB9dA0efY",
  authDomain: "maenupdates.firebaseapp.com",
  databaseURL: "https://maenupdates.firebaseio.com",
  projectId: "maenupdates",
  storageBucket: "maenupdates.appspot.com",
  messagingSenderId: "218573665775",
  appId: "1:218573665775:web:27ad26b4be66ce1f9db21a",
  measurementId: "G-Q4XFHP1SLR"
};
firebase.initializeApp(config);
var createFirebase = firebase.initializeApp(config, "Secondary");

const db = firebase.database();
const auth = firebase.auth();
const storageRef = firebase.storage().ref();
const perf = firebase.performance();
const store = firebase.firestore();

export {
  firebase,
  db,
  auth,
  perf,
  createFirebase,
  store,
  storageRef
};
